module.exports = __webpack_public_path__ + "static/mw-winner.40e1bbcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mw-winner.png
// module id = 218
// module chunks = 23899280101116 35783957827783 95715928098905 128049163870319